"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordQueryParamName = void 0;
exports.recordQueryParamName = "editRecord";
